import { defineComponent as _defineComponent } from 'vue'
import Cookies from 'js-cookie';
import Dropdown from "primevue/dropdown";
import { ref, computed,
  onMounted, reactive, getCurrentInstance } from "vue";
import {RegistrationModel} from "@/views/pages/auth/registration";
import GuestFormGroup from "@/components/forms/guest/GuestFormGroup.vue";
import Skeleton from "@/components/decorations/Skeleton.vue";
import UsertypeRadioButton from "@/views/pages/auth/reg/UsertypeRadioButton.vue";
import VueI18n from "vue-i18n";
import RegistrationCaptcha from "@/views/pages/auth/reg/RegistrationCaptcha.vue";
import {UserCategoryGroup} from "@/backoffice/components/pages/settings/usercategory/user-category";
import  "primevue/resources/primevue.min.css";
import {useRoute, useRouter} from "vue-router/composables";

declare function ym(a, b, c): void;
// declare function $t(a): string;


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationSetupPage',
  props: {
  values: {
    type: Object,
    default: () => {
      return {};
    }
  }
},
  setup(__props) {

const props = __props;

const route = useRoute();

const registrationQueryValues = computed(() => {
  return {
    refCode: route.query.from || Cookies.get('ReferralCode') || '',
    inviteCode: route.query.invite || '',
    referrer: Cookies.get('TheReferer') || '',
    category: route.query.a || '',
  }
})



const model = reactive(new RegistrationModel());
const redirecting = ref(false);
const activityRequired = ref(true)

const isModelDisabled = computed(() => {
  return model.submitstate.isLoading || redirecting.value;
})
const isIndividual = computed(() => {
  return model.values.userType === 'INDIVIDUAL';
})
const isBusiness = computed(() => {
  return model.values.userType === 'LEGAL';
})

const selectedCategoryOther = computed(() => {
  const category = model.categories.find((category) => category.id === model.values.activity);

  return category && category.other;
})

const locale = computed(() => {
  return getCurrentInstance()?.proxy?.$i18n.locale || 'ru';
})

const isRegisterDisabled = computed(() => {
  return isModelDisabled.value
    || !model.values.acceptedAgreement;
})


const sortingOrder = [
  UserCategoryGroup.individual,
  UserCategoryGroup.business,
  UserCategoryGroup.business_service,
  UserCategoryGroup.business_advertising_network,
  UserCategoryGroup.business_affiliate_network,
  UserCategoryGroup.business_webmaster_service,
  UserCategoryGroup.business_marketing_agency,
];

const businessGroups = [
  UserCategoryGroup.business,
  UserCategoryGroup.business_service,
  UserCategoryGroup.business_advertising_network,
  UserCategoryGroup.business_affiliate_network,
  UserCategoryGroup.business_webmaster_service,
  UserCategoryGroup.business_marketing_agency,
];

const categoryOptions = computed(() => {
  const $i18n = getCurrentInstance()?.proxy.$i18n as VueI18n;


  const result = model.categories.filter((val) => {
    return val.visible && val.usertype == model.values.userType;
  }).sort((a, b) => {
    const key = locale.value == 'ru' ? 'name' : 'name_en';
    return a[key].localeCompare(b[key]);
  }).sort((a, b) => {
    return - sortingOrder.indexOf(a.group) + sortingOrder.indexOf(b.group);
  }).sort((a, b) => {
    return a.other ? 1 : -1;
  }).map((val) => {
    return {...val,
      lname: $i18n.locale == 'ru' ? val.name : val.name_en,
      disabled: false};
  })

  sortingOrder.forEach((group) => {
    const gIndex = result.findIndex((val) => {
      return val.group == group;
    })

    if (gIndex >= 0)
    {
      result.splice(gIndex, 0, {
        id: group,
        name: $i18n.t('category_name.' + group) as string,
        name_en: $i18n.t('category_name.' + group) as string,
        lname: $i18n.t('category_name.' + group) as string,
        group: 'root',
        usertype: result[gIndex].usertype,
        visible: true,
        other: false,
        disabled: true,
      });
    }
  })


  const oIndex = result.findIndex((val) => {
    return val.other;
  })

  if (oIndex >= 0)
  {
    result.splice(oIndex, 0, {
      id: 'other',
      name: $i18n.t('Другое') as string,
      name_en: $i18n.t('Другое') as string,
      lname: $i18n.t('Другое') as string,
      group: 'root',
      usertype: result[oIndex].usertype,
      visible: true,
      other: false,
      disabled: true,
    });
  }

  // const groups = result.reduce((acc, val) => {
  //   if (!acc[val.group]) {
  //     acc[val.group] = [];
  //   }
  //   acc[val.group].push(val);
  //   return acc;
  // }, {});
  //
  // console.log('groups', groups)

  return result;
  // return this.model.categories.map((val) => {
  //   return {
  //     value: val.id,
  //     text: val.name,
  //   };
  // });

})

const yandexMetrikaRegisterFinal = (usertype) => {

  try {

    if (typeof ym === 'function') {
      if (usertype === 'INDIVIDUAL') {
        ym(55378108,'reachGoal','REG_PERSONAL')
      }
      if (usertype === 'LEGAL') {
        ym(55378108,'reachGoal','REG_BUSINESS')
      }
    }
  } catch (e) {

  }
}

const regCaptcha = ref(null);

const submit = () => {
  model.errors.clear();
  model.submit().then(() => {
    redirecting.value = true;
    yandexMetrikaRegisterFinal(model.values.userType);

    setTimeout(() => {
      window.location.href = '/regconfirm';
    }, 1000);
  }).catch((e) => {
    regCaptcha.value?.forceUpdate();
    model.values.captchaCode = '';
  })
}

const onUsertypeUpdate = (usertype) => {
  model.values.userType = usertype;
  model.values.activity = null;
}

onMounted(() => {
  model.values = {...model.values, ...registrationQueryValues.value};
  model.loadCategories();
})

return { __sfc: true,route, registrationQueryValues, props, model, redirecting, activityRequired, isModelDisabled, isIndividual, isBusiness, selectedCategoryOther, locale, isRegisterDisabled, sortingOrder, businessGroups, categoryOptions, yandexMetrikaRegisterFinal, regCaptcha, submit, onUsertypeUpdate, Cookies, Dropdown, ref, computed, onMounted, reactive, getCurrentInstance, RegistrationModel, GuestFormGroup, Skeleton, UsertypeRadioButton, VueI18n, RegistrationCaptcha, UserCategoryGroup, useRoute, useRouter }
}

})